import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/AppHome.vue'),
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/AppAbout.vue'),
    },
    {
        path: `/product/:id`,
        name: 'Product',
        component: () => import('@/views/AppProduct.vue'),
        props: true
    }
];

export default new Router({
    mode: 'history',
    routes,
});
